import { render } from "./PanelComponent.vue?vue&type=template&id=6f2bb59e&scoped=true"
import script from "./PanelComponent.vue?vue&type=script&lang=js"
export * from "./PanelComponent.vue?vue&type=script&lang=js"

import "./PanelComponent.vue?vue&type=style&index=0&id=6f2bb59e&lang=scss&scoped=true"
import "./PanelComponent.vue?vue&type=style&index=1&id=6f2bb59e&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2bb59e"]])

export default __exports__